module.exports = __webpack_public_path__ + "static/US-VAS-03469_HCP_Blink_Rx_EMR_Troubleshooting_Guide_Oct_21-dd1fdb9e0d62b52633637e43d494fd12.pdf";